// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  In this file, we write the styles for dropdown component
*/

.dropdown {
  width: 100%;
  display: flex;
  gap: 9px;
  /* margin-bottom: 3px; */
}

.dropdownctrl .colWiseControl {
  display: flex;
  flex-direction: column;
  width: 100%;
  /*gap: 9px; */
  /* gap: 144px; */
  /* display: grid; */
  /* grid-template-columns: 167px 1fr; */
  /* grid-template-columns: auto 1fr; */

  /* display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); */
  /*grid-template-columns:
    minmax(100px, max-content)
    repeat(auto-fill, 200px) 20%;*/
  /* gap: 1em; */
  justify-content: space-between;
}

/*  variant type filled */
.Required-color {
  color: var(--required-color);
}

.MuiFormControl-root.dropdown .MuiInputLabel-filled {
  margin: 0px;
  padding: 0px;
  position: relative;
  transform: inherit;
  /* color: #838383; */
  /* color: var(--controllabel-colour); */
  font-family: var(--label-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  letter-spacing: var(--font-letter-space);
  min-width: 38%;
  display: flex;
  align-items: center;
}

.Formviwer .MuiInputLabel-root {
  display: none;
}

.MuiFormControl-root.dropdown .MuiInputLabel-filled.MuiInputLabel-shrink {
  transform: none;
  /* color: #838383; */
  /*  color: var(--controllabel-colour); */
  font-family: var(--label-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  letter-spacing: var(--font-letter-space);
}

.MuiFormControl-root.dropdown .MuiFilledInput-underline:before {
  border-bottom: none;
}

.MuiFormControl-root.dropdown .MuiFilledInput-underline:after {
  border-bottom: none;
}

.MuiFormControl-root.dropdown .MuiFilledInput-input {
  /* background: white; */
  background-color: var(--gridbgcolor);
  /* background: #f9f9f9; */
  /* border: 1px solid #d6d6d6; */
  /* border: 1px solid var(--controlborder-colour); */
  /* border-radius: 8px; */
  box-sizing: border-box;
  height: 35px;
  /* padding: 7px 12px 20px; */
  padding: 10px 12px 10px;
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  border-radius: 4px;
  letter-spacing: var(--font-letter-space);
}

.contraventionsection .MuiFormControl-root.dropdown .MuiFilledInput-input {
  background-color: var(--whiteColour);
  border: var(--inputControlBorderSize) var(--inputControlBorderColor) solid;
}
.contraventionsection .MuiSelect-select:focus {
  background-color: var(--whiteColour) !important;
  display: block;
}
.contraventionsection .dropdownctrl .rowWiseControl {
  width: 100%;
}

.MuiFormControl-root.dropdown .MuiFilledInput-root:hover {
  border-bottom: none;
}

.MuiFormControl-root.dropdown .MuiFilledInput-underline:hover:before {
  border-bottom: none;
}

.MuiFormControl-root.dropdown-inputMarginDense {
  padding-top: 15px;
}

/*  end*/

/* Cell css -- Start*/

.Dropdownstatus-open-outer .MuiFilledInput-input {
  background-color: red !important;
}

.Dropdownstatus-closed-outer .MuiFilledInput-input {
  background-color: green !important;
}

.Dropdownstatus-pending-outer .MuiFilledInput-input {
  background-color: lightsalmon !important;
}

.Dropdownstatus-onhold-outer .MuiFilledInput-input {
  background-color: yellow !important;
}

/* Cell css -- End*/

/* .MuiFormControl-root.dropdown .MuiInputLabel-filled {
    transform: inherit;
    margin-top: -8px;
  }
  .MuiFormControl-root.dropdown .MuiInputLabel-filled.MuiInputLabel-marginDense {
    transform: none;
    margin-top: -8px;
    border-radius: 8px;
  }
  
  /*  end*/

.MuiInputBase-root {
  font-size: 0.875rem;
  font-family: var(--default-FontName);
}

.MuiSelect-icon {
  color: black;
}

/*  Formviwer Label Css -- Start */
.dropdownctrl {
  display: flex;
  width: 100%;
}

.MuiMenuItem-root {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}

.Formviwer .MuiInputLabel-root {
  display: none;
}

span.FormviwerDropdown-Label {
  width: 200px;
  /* max-width: 200px;
    min-width: 200px; */
  /* width: 40%; */
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 15px;
  font-family: var(--label-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  overflow-wrap: anywhere;
  /* gap: 5px; */
  justify-content: var(--textahrlignment);
}

.tab-panel .FormviwerDropdown-Label {
  margin-top: 0px !important;
  justify-content: var(--textahrlignment);
}

/* .Formviwer .MuiInput-underline:before {
    border-bottom: none;
  } */

.Formviwer .MuiInput-underline:after {
  border: none;
}

.Formviwer .Mui-focused .MuiInputBase-inputMarginDense:hover {
  border: none;
}

.MuiSelect-select:focus {
  /* background: white !important; */
  background-color: transparent !important;
  display: block;
}

.formviewer .form-element .autocompletectrl .dropdown .Mui-focused {
  border: 1px solid var(--controlborder-colour);
}

.Formviwer.MuiInputBase-formControl.MuiInput-formControl.MuiInputBase-marginDense.MuiInput-marginDense
  svg.MuiSvgIcon-root.MuiSelect-icon {
  display: none;
}

.dropdown
  .Formviwer.MuiInputBase-formControl.MuiInput-formControl.MuiInputBase-marginDense.MuiInput-marginDense:hover
  svg.MuiSvgIcon-root.MuiSelect-icon {
  display: block;
  color: black;
}

.Text-field-container {
  width: 100%;
}

.dropdown .MuiSelect-icon {
  color: black;
}

/* .Formviwer .MuiInputBase-inputMarginDense {
    padding: 7px;
  } */
/* .Formviwer .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
  } */
/*  Formviwer Label Css -- Start */
.icon-padding {
  display: flex;
  /* padding-right: 10px; */
  align-items: center;
  padding: 0 5px;
}

/* .dropdown .ControlLabelDiv {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  } */
.autocompletectrl,
.dropdownctrl .rowWiseControl {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 9px;
}

.autocompletectrl .colWiseControl {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.autocompletectrl .controlLabelDiv {
  font-family: var(--labelFontName);
  font-size: var(--labelFontSize);
  font-weight: var(--labelFontWeight);
  color: var(--labelFontName);
  line-height: var(--labelFontColor);
  display: flex;
  flex-direction: row;
  align-items: center;
}

.autocompletectrl,
.dropdownctrl .rowWiseControl .controlLabelDiv {
  width: 200px;
}

.contraventionsection .dropdownctrl .controlLabelDiv {
  font-weight: var(--header-FontWeight);
}

.autocompletectrl .iconPadding {
  height: 16px;
  width: 16px;
}

.autocompletectrl .MuiSelect-select:focus {
  background-color: white;
}

.dropdownctrl .outlineerror .MuiInputBase-root {
  border: 1px solid red;
  border-radius: 4px;
}

.dropdownOptionMenuItem .dropdownOptionText {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

/* .dropdownctrl .MuiFilledInput-root {
  margin-left: -114px;
  width: 254px;
} */

@media (min-width: 300px) and (max-width: 900px) {
  .dropdownctrl .colWiseControl {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    gap: 11px;
  }
}

@media (min-width: 520px) and (max-width: 700px) {
  .MuiFormControl-root.dropdown .MuiInputLabel-filled {
    margin: 0px;
    padding: 0px;
    position: relative;
    transform: inherit;
    /* color: #838383; */
    /* color: var(--controllabel-colour); */
    font-family: var(--label-FontName);
    font-size: var(--label-FontSize);
    font-weight: var(--label-FontWeight);
    color: var(--label-FontColour);
    letter-spacing: var(--font-letter-space);
    min-width: 46%;
  }
}

/* @media (min-width: 300px) {
  .addressline.title {
    margin-top: 5px;
  }
} */

@media (min-width: 300px) and (max-width: 799px) {
  .fileuploadparas {
    margin-bottom: 12px;
  }
}

.dropdown .MuiSelect-iconFilled {
  right: 0px !important;
}

/* .dropdown span {
  margin-left: 3px;
} */

svg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconFilled {
  margin-right: 5px;
}

.MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {
  min-width: 0px !important;
}

/* svg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconFilled {
  position: static !important;
} */

.MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {
  background-color: var(--gridbgcolor);
  border-radius: 4px;
}

.contraventionsection
  .MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {
  width: 100%;
}

.ddl_ListData {
  height: 200px;
}

.userSetupPage
  .userCodeSection
  .userDataSection
  .roleSetup
  .MuiFormControl-root.dropdown
  .MuiFilledInput-input {
  background-color: var(--ToolbarBackgroundColour);
}

.userSetupPage
  .userCodeSection
  .userDataSection
  .roleSetup
  .MuiSelect-select:focus {
  background-color: var(--ToolbarBackgroundColour) !important;
}

.userSetupPage
  .userCodeSection
  .userDataSection
  .roleSetup
  .MuiSelect-root.MuiSelect-select.Mui-disabled {
  background-color: var(--disableBgColor);
}

.contraventionsection .MuiSelect-root.MuiSelect-select.Mui-disabled {
  background-color: var(--inputControlDisabledBgColor) !important;
  pointer-events: none;
  color: var(--inputControlDisabledTextColor);
  border: none;
}

.contraventionsection
  svg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconFilled.Mui-disabled {
  display: none;
}

.MuiFormControl-root.dropdown .MuiFilledInput-input em p {
  margin-left: 0px;
  font-family: var(--default-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--placeHolderColor);
  opacity: 1;
  transition: unset;
  font-style: normal;
}
.MuiFormControl-root.dropdown .MuiFilledInput-input p {
  margin: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/dropdown/Dropdown.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;CAEC;;AAED;EACE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,qCAAqC;;EAErC;gEAC8D;EAC9D;;kCAEgC;EAChC,cAAc;EACd,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,wCAAwC;EACxC,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,mDAAmD;EACnD,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,0EAA0E;AAC5E;AACA;EACE,+CAA+C;EAC/C,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,QAAQ;;AAER,qBAAqB;;AAErB;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;;AAEnB;;;;;;;;;;UAUU;;AAEV;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ;uBACqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;;KAEK;;AAEL;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;KAEK;AACL;;KAEK;AACL,kCAAkC;AAClC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;KAIK;AACL;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;;;GAGG;;AAEH;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,uCAAuC;IACvC,kCAAkC;IAClC,gCAAgC;IAChC,oCAAoC;IACpC,8BAA8B;IAC9B,wCAAwC;IACxC,cAAc;EAChB;AACF;;AAEA;;;;GAIG;;AAEH;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,gDAAgD;AAClD;;AAEA;;;;;EAKE,2DAA2D;AAC7D;;AAEA;;;;;EAKE,uCAAuC;AACzC;;AAEA;EACE,+DAA+D;EAC/D,oBAAoB;EACpB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n/*\n  In this file, we write the styles for dropdown component\n*/\n\n.dropdown {\n  width: 100%;\n  display: flex;\n  gap: 9px;\n  /* margin-bottom: 3px; */\n}\n\n.dropdownctrl .colWiseControl {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  /*gap: 9px; */\n  /* gap: 144px; */\n  /* display: grid; */\n  /* grid-template-columns: 167px 1fr; */\n  /* grid-template-columns: auto 1fr; */\n\n  /* display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); */\n  /*grid-template-columns:\n    minmax(100px, max-content)\n    repeat(auto-fill, 200px) 20%;*/\n  /* gap: 1em; */\n  justify-content: space-between;\n}\n\n/*  variant type filled */\n.Required-color {\n  color: var(--required-color);\n}\n\n.MuiFormControl-root.dropdown .MuiInputLabel-filled {\n  margin: 0px;\n  padding: 0px;\n  position: relative;\n  transform: inherit;\n  /* color: #838383; */\n  /* color: var(--controllabel-colour); */\n  font-family: var(--label-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  letter-spacing: var(--font-letter-space);\n  min-width: 38%;\n  display: flex;\n  align-items: center;\n}\n\n.Formviwer .MuiInputLabel-root {\n  display: none;\n}\n\n.MuiFormControl-root.dropdown .MuiInputLabel-filled.MuiInputLabel-shrink {\n  transform: none;\n  /* color: #838383; */\n  /*  color: var(--controllabel-colour); */\n  font-family: var(--label-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  letter-spacing: var(--font-letter-space);\n}\n\n.MuiFormControl-root.dropdown .MuiFilledInput-underline:before {\n  border-bottom: none;\n}\n\n.MuiFormControl-root.dropdown .MuiFilledInput-underline:after {\n  border-bottom: none;\n}\n\n.MuiFormControl-root.dropdown .MuiFilledInput-input {\n  /* background: white; */\n  background-color: var(--gridbgcolor);\n  /* background: #f9f9f9; */\n  /* border: 1px solid #d6d6d6; */\n  /* border: 1px solid var(--controlborder-colour); */\n  /* border-radius: 8px; */\n  box-sizing: border-box;\n  height: 35px;\n  /* padding: 7px 12px 20px; */\n  padding: 10px 12px 10px;\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  border-radius: 4px;\n  letter-spacing: var(--font-letter-space);\n}\n\n.contraventionsection .MuiFormControl-root.dropdown .MuiFilledInput-input {\n  background-color: var(--whiteColour);\n  border: var(--inputControlBorderSize) var(--inputControlBorderColor) solid;\n}\n.contraventionsection .MuiSelect-select:focus {\n  background-color: var(--whiteColour) !important;\n  display: block;\n}\n.contraventionsection .dropdownctrl .rowWiseControl {\n  width: 100%;\n}\n\n.MuiFormControl-root.dropdown .MuiFilledInput-root:hover {\n  border-bottom: none;\n}\n\n.MuiFormControl-root.dropdown .MuiFilledInput-underline:hover:before {\n  border-bottom: none;\n}\n\n.MuiFormControl-root.dropdown-inputMarginDense {\n  padding-top: 15px;\n}\n\n/*  end*/\n\n/* Cell css -- Start*/\n\n.Dropdownstatus-open-outer .MuiFilledInput-input {\n  background-color: red !important;\n}\n\n.Dropdownstatus-closed-outer .MuiFilledInput-input {\n  background-color: green !important;\n}\n\n.Dropdownstatus-pending-outer .MuiFilledInput-input {\n  background-color: lightsalmon !important;\n}\n\n.Dropdownstatus-onhold-outer .MuiFilledInput-input {\n  background-color: yellow !important;\n}\n\n/* Cell css -- End*/\n\n/* .MuiFormControl-root.dropdown .MuiInputLabel-filled {\n    transform: inherit;\n    margin-top: -8px;\n  }\n  .MuiFormControl-root.dropdown .MuiInputLabel-filled.MuiInputLabel-marginDense {\n    transform: none;\n    margin-top: -8px;\n    border-radius: 8px;\n  }\n  \n  /*  end*/\n\n.MuiInputBase-root {\n  font-size: 0.875rem;\n  font-family: var(--default-FontName);\n}\n\n.MuiSelect-icon {\n  color: black;\n}\n\n/*  Formviwer Label Css -- Start */\n.dropdownctrl {\n  display: flex;\n  width: 100%;\n}\n\n.MuiMenuItem-root {\n  padding-top: 7px !important;\n  padding-bottom: 7px !important;\n}\n\n.Formviwer .MuiInputLabel-root {\n  display: none;\n}\n\nspan.FormviwerDropdown-Label {\n  width: 200px;\n  /* max-width: 200px;\n    min-width: 200px; */\n  /* width: 40%; */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 15px;\n  font-family: var(--label-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  display: flex;\n  /* justify-content: space-between; */\n  align-items: center;\n  overflow-wrap: anywhere;\n  /* gap: 5px; */\n  justify-content: var(--textahrlignment);\n}\n\n.tab-panel .FormviwerDropdown-Label {\n  margin-top: 0px !important;\n  justify-content: var(--textahrlignment);\n}\n\n/* .Formviwer .MuiInput-underline:before {\n    border-bottom: none;\n  } */\n\n.Formviwer .MuiInput-underline:after {\n  border: none;\n}\n\n.Formviwer .Mui-focused .MuiInputBase-inputMarginDense:hover {\n  border: none;\n}\n\n.MuiSelect-select:focus {\n  /* background: white !important; */\n  background-color: transparent !important;\n  display: block;\n}\n\n.formviewer .form-element .autocompletectrl .dropdown .Mui-focused {\n  border: 1px solid var(--controlborder-colour);\n}\n\n.Formviwer.MuiInputBase-formControl.MuiInput-formControl.MuiInputBase-marginDense.MuiInput-marginDense\n  svg.MuiSvgIcon-root.MuiSelect-icon {\n  display: none;\n}\n\n.dropdown\n  .Formviwer.MuiInputBase-formControl.MuiInput-formControl.MuiInputBase-marginDense.MuiInput-marginDense:hover\n  svg.MuiSvgIcon-root.MuiSelect-icon {\n  display: block;\n  color: black;\n}\n\n.Text-field-container {\n  width: 100%;\n}\n\n.dropdown .MuiSelect-icon {\n  color: black;\n}\n\n/* .Formviwer .MuiInputBase-inputMarginDense {\n    padding: 7px;\n  } */\n/* .Formviwer .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom: none;\n  } */\n/*  Formviwer Label Css -- Start */\n.icon-padding {\n  display: flex;\n  /* padding-right: 10px; */\n  align-items: center;\n  padding: 0 5px;\n}\n\n/* .dropdown .ControlLabelDiv {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n  } */\n.autocompletectrl,\n.dropdownctrl .rowWiseControl {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  gap: 9px;\n}\n\n.autocompletectrl .colWiseControl {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.autocompletectrl .controlLabelDiv {\n  font-family: var(--labelFontName);\n  font-size: var(--labelFontSize);\n  font-weight: var(--labelFontWeight);\n  color: var(--labelFontName);\n  line-height: var(--labelFontColor);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.autocompletectrl,\n.dropdownctrl .rowWiseControl .controlLabelDiv {\n  width: 200px;\n}\n\n.contraventionsection .dropdownctrl .controlLabelDiv {\n  font-weight: var(--header-FontWeight);\n}\n\n.autocompletectrl .iconPadding {\n  height: 16px;\n  width: 16px;\n}\n\n.autocompletectrl .MuiSelect-select:focus {\n  background-color: white;\n}\n\n.dropdownctrl .outlineerror .MuiInputBase-root {\n  border: 1px solid red;\n  border-radius: 4px;\n}\n\n.dropdownOptionMenuItem .dropdownOptionText {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n/* .dropdownctrl .MuiFilledInput-root {\n  margin-left: -114px;\n  width: 254px;\n} */\n\n@media (min-width: 300px) and (max-width: 900px) {\n  .dropdownctrl .colWiseControl {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    justify-content: space-between;\n    gap: 11px;\n  }\n}\n\n@media (min-width: 520px) and (max-width: 700px) {\n  .MuiFormControl-root.dropdown .MuiInputLabel-filled {\n    margin: 0px;\n    padding: 0px;\n    position: relative;\n    transform: inherit;\n    /* color: #838383; */\n    /* color: var(--controllabel-colour); */\n    font-family: var(--label-FontName);\n    font-size: var(--label-FontSize);\n    font-weight: var(--label-FontWeight);\n    color: var(--label-FontColour);\n    letter-spacing: var(--font-letter-space);\n    min-width: 46%;\n  }\n}\n\n/* @media (min-width: 300px) {\n  .addressline.title {\n    margin-top: 5px;\n  }\n} */\n\n@media (min-width: 300px) and (max-width: 799px) {\n  .fileuploadparas {\n    margin-bottom: 12px;\n  }\n}\n\n.dropdown .MuiSelect-iconFilled {\n  right: 0px !important;\n}\n\n/* .dropdown span {\n  margin-left: 3px;\n} */\n\nsvg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconFilled {\n  margin-right: 5px;\n}\n\n.MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {\n  min-width: 0px !important;\n}\n\n/* svg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconFilled {\n  position: static !important;\n} */\n\n.MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {\n  background-color: var(--gridbgcolor);\n  border-radius: 4px;\n}\n\n.contraventionsection\n  .MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {\n  width: 100%;\n}\n\n.ddl_ListData {\n  height: 200px;\n}\n\n.userSetupPage\n  .userCodeSection\n  .userDataSection\n  .roleSetup\n  .MuiFormControl-root.dropdown\n  .MuiFilledInput-input {\n  background-color: var(--ToolbarBackgroundColour);\n}\n\n.userSetupPage\n  .userCodeSection\n  .userDataSection\n  .roleSetup\n  .MuiSelect-select:focus {\n  background-color: var(--ToolbarBackgroundColour) !important;\n}\n\n.userSetupPage\n  .userCodeSection\n  .userDataSection\n  .roleSetup\n  .MuiSelect-root.MuiSelect-select.Mui-disabled {\n  background-color: var(--disableBgColor);\n}\n\n.contraventionsection .MuiSelect-root.MuiSelect-select.Mui-disabled {\n  background-color: var(--inputControlDisabledBgColor) !important;\n  pointer-events: none;\n  color: var(--inputControlDisabledTextColor);\n  border: none;\n}\n\n.contraventionsection\n  svg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconFilled.Mui-disabled {\n  display: none;\n}\n\n.MuiFormControl-root.dropdown .MuiFilledInput-input em p {\n  margin-left: 0px;\n  font-family: var(--default-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--placeHolderColor);\n  opacity: 1;\n  transition: unset;\n  font-style: normal;\n}\n.MuiFormControl-root.dropdown .MuiFilledInput-input p {\n  margin: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
